<template>
  <div v-if="eventos && eventos.length > 0" id="carousel-portada" class="container no_space" v-resize="onResize">
    <div class="clear"></div>
    <h1 v-if="titulo" class="mt-4" >{{$t(titulo)}}</h1>
		<v-carousel :height="sliderHeight" v-if="sliderHeight" hide-controls>
      <v-carousel-item
        v-for="(item, i) in eventos"
        :key="i"
				:src="miImagen(item, configuracion.imagen)"
      >
        <v-layout
          slot="placeholder"
          fill-height
          align-center
          justify-center
          ma-0
        >
          <v-progress-circular
            indeterminate
            :color="colorDestacado"
          ></v-progress-circular>
        </v-layout>
        <v-layout style="width: 100%" row fill-height>
          <v-card
            color="transparent"
            style="width: 100%"
            flat
            :to="`/${$i18n.locale}/detalle/${item.cmsID}/${item.Recinto[0].Id}`"
          >
          </v-card>
        </v-layout>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { globales } from "./comunes";

export default {
  mixins: [globales],
  props: ["seccion"],
  data() {
    {
      return {};
    }
  },
  methods: {
		onResize(event) {
      const slider = document.getElementById("carousel-portada");
      this.windowSize = { x: slider.clientWidth, y: slider.clientHeight };

      // console.log('rezise', slider)
    },
	},
  computed: {
		sliderHeight() {
      const imagen = this.configuracion.imagen;
      //   const imagen = "destacados";
      const ratio = this.imagen.ratio;

      return this.windowSize.x / 2.6;
    },
    seccionActual() {
      const secciones = this.layoutSecciones;
      // console.log("Secciones existes todas", this.layoutSecciones);
      const seccion = this.seccion;
      if (!secciones.hasOwnProperty(seccion)) {
        // console.log("Seccion no existe", seccion);
      }
      return this.layoutSecciones[this.seccion];
    },
    eventos() {
      // console.log("mi seccion actual existes", this.seccionActual);
      const secciones = this.$store.state.layout.secciones;
      const seccionActual = secciones[this.seccion]
        ? secciones[this.seccion]
        : null;
      const visibles = this.configuracion.visibles;
      const items = seccionActual["items"]
        ? seccionActual.items.slice(0, visibles)
        : [];
      const eventosJanto = this.$store.state.eventosJanto;
      const ahora = this.Hoy.ahora;

      const misEventos = items.map(evento => {
        if (eventosJanto[evento]) {
          const item = eventosJanto[evento];

          const id = item.webId;
          const itemWeb = this.$store.state.itemsWeb.find(i => i.id == id);
          if (itemWeb) {
            item.cms = itemWeb;
          }

          if (item.FFinVentaMax > ahora && item.FInicioVentaMin < ahora) {
            return item;
          }
        }
      });

      return misEventos.filter(e => e);
    },
    configuracion() {
      return this.seccionActual.configuracion;
    },
    titulo() {
      if (this.configuracion.labelVisible) {
        return this.configuracion.titulo;
      }
    },
    imagen() {
      const src = this.configuracion.imagen;
      const ratio = this.ratios[src];

      return {
        src,
        ratio,
      };
    },
    disposicion() {
      return this.configuracion.columnas;
    },
    // resto() {
    //   const numero = this.configuracion.visibles;
    //   return this.seccionActual.eventos.slice(numero);
    // },
  },
};
</script>
